import { Box, Button, TextField, Typography } from '@mui/material';
import { palette } from '../../theme/palette';
import { styled } from '@mui/material/styles';

export const Root = styled(Box)`
  display: flex;
  align-items: center;
  background: ${palette.custom.white};
  border-radius: 1px;
  border: 0.75px solid ${palette.custom.grey};
  box-sizing: border-box;
  justify-content: space-between;
  color: ${palette.custom.grey};
  height: 100%;
`;

export const QuantityContainer = styled(TextField)`
  .MuiInputBase-root {
    border: 0;
    border-radius: 0px;
    height: 100%;
  }
  .MuiInputBase-input {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0px;
    padding: 2px;
    text-align: center;
  }
  //For firefox
  input[type='number'] {
    -moz-appearance: textfield;
  }
  //For other browsers
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
  .MuiOutlinedInput-notchedOutline {
    border: 0px;
  }
`;

export const QuantityUpdateIcon = styled(Typography)`
  color: inherit;
  padding-bottom: 5px;
`;

export const QuantityUpdateButton = styled(Button)`
  border: 0;
  border-radius: 5px;
  background: ${palette.custom.white};
  color: inherit;
  cursor: pointer;
  width: 40px;
  height: 100%;
  min-width: unset;
  padding-bottom: 4px;
  :hover {
    background: ${palette.custom.white};
    color: inherit;
  }
`;
